<div class="team-form-main-container">
  <ng-scrollbar [autoHeightDisabled]="false" [autoWidthDisabled]="false">
    <div class="scroll-content">
      <form [formGroup]="teamForm" class="form-content">
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="100%">
          <mat-label>{{ 'Team Name' | platformLabel }}</mat-label>
          <input
            matInput
            forbidAngleBrackets
            type="text"
            formControlName="name"
          />
          @if (teamForm.get('name').hasError('unique')) {
            <mat-error>
              {{ teamForm.get('name').getError('unique') }}
            </mat-error>
          }
          @if (teamForm.get('name').hasError('notEmpty')) {
            <mat-error>
              {{ teamForm.get('name').getError('notEmpty') }}
            </mat-error>
          }
          @if (teamForm.get('name').hasError('minlength')) {
            <mat-error> Team name must be at least 4 characters </mat-error>
          }
          @if (teamForm.get('name').hasError('maxlength')) {
            <mat-error> Team name can be at most 255 characters </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="100%">
          <mat-label>Public Name</mat-label>
          <input
            matInput
            forbidAngleBrackets
            type="text"
            formControlName="publicName"
            id="public-team-name-input"
          />
          @if (teamForm.get('publicName').hasError('minlength')) {
            <mat-error> Team name must be at least 4 characters </mat-error>
          }
          @if (teamForm.get('publicName').hasError('maxlength')) {
            <mat-error> Team name can be at most 255 characters </mat-error>
          }
        </mat-form-field>
        @if (cloneMode) {
          <div class="clone-container">
            <mat-checkbox
              formControlName="copyPeople"
              color="primary"
              id="copy-people-checkbox"
              >Copy people to the new {{ 'team' | platformLabel }}</mat-checkbox
            >
          </div>
        }
        <div fxLayoutAlign="space-between" formGroupName="dateGroup">
          <mat-form-field appearance="outline" floatLabel="always" fxFlex="47%">
            <mat-label>Start Date</mat-label>
            <input
              matInput
              [matDatepicker]="startPicker"
              formControlName="startDate"
              [errorStateMatcher]="matcher"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="startPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
            @if (dateFormGroup.hasError('startDateBeforeEndDate')) {
              <mat-error> Start date must be before the end date </mat-error>
            }
            @if (dateFormGroup.hasError('requiredStartDate')) {
              <mat-error>
                Start date is required if an end date is set
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline" floatLabel="always" fxFlex="47%">
            <mat-label>End Date</mat-label>
            <input
              matInput
              [matDatepicker]="endPicker"
              formControlName="endDate"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="endPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>
        </div>
        @if (cloneMode) {
          <div>
            @if (attributesEditorDataSource.hasAttributes) {
              <mat-divider></mat-divider>
            }
            <attributes-editor
              #attributesEditor
              class="make-labels-grey"
              [dataSource]="attributesEditorDataSource"
              [onTeamForm]="true"
              fxFlexWidth="100%"
            >
            </attributes-editor>
          </div>
        }
      </form>
    </div>
  </ng-scrollbar>
</div>
